import { render, staticRenderFns } from "./WorkOrderTypeBadge.vue?vue&type=template&id=57f7a5b1&scoped=true&"
import script from "./WorkOrderTypeBadge.vue?vue&type=script&lang=js&"
export * from "./WorkOrderTypeBadge.vue?vue&type=script&lang=js&"
import style0 from "./WorkOrderTypeBadge.vue?vue&type=style&index=0&id=57f7a5b1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f7a5b1",
  null
  
)

export default component.exports